export default __webpack_public_path__ + "static/media/cheese-cone.fb7ee7ea.jpg";